<template>
  <el-dialog
    append-to-body
    :title="$t('manage_payroll_items')"
    :visible.sync="visible"
    v-if="visible"
    width="696px"
    :close-on-click-modal="false"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <!-- 结算类型 -->
      <el-form-item :label="$t('33')" class="type">
        <el-radio-group v-model="form.settlement_type" @change="getList">
          <el-radio :label="1">{{ $t('401') }}</el-radio> <!-- 月结 -->
          <el-radio :label="2">{{ $t('400') }}</el-radio> <!-- 日结 -->
        </el-radio-group>
      </el-form-item>
      <div class="tip-text">
        <i class="el-icon-warning icon-warning"></i>
        <p>{{ $t('payroll_salary_3') }}</p>
      </div>

      <el-tabs v-model="form.cate_id" @tab-click="getList">
        <el-tab-pane :label="$t('1397')" name="4"></el-tab-pane> <!-- 固定工资 -->
        <el-tab-pane :label="$t('1398')" name="6"></el-tab-pane> <!-- 不固定工资 -->
      </el-tabs>
      <el-table :data="tableData">
        <!-- 名称 -->
        <el-table-column :label="$t('1345')">
          <template slot-scope="scope">
            <el-form-item prop="name" v-if="scope.row.isEdit">
              <el-input
                type="text"
                @change.native="e => handlerName(e)"
                v-model="form.name"  />
            </el-form-item>
            <p v-else>
              <span>{{ scope.row.name }}</span>
              <el-tag v-if="Number(scope.row.is_use)" class="tag" type="warning">{{ $t('payroll_salary_4') }}</el-tag>
            </p>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="address" :label="$t('70')" width="150">
          <template slot-scope="scope">
            <!-- 确认取消 -->
            <div v-if="scope.row.isEdit">
              <el-button type="text" @click="handlerSave" :loading="load">{{ $t('67') }}</el-button>
              <el-button type="text" @click="handlerCancel(scope.row)" :disabled="load">{{ $t('66') }}</el-button>
            </div>
            <!-- 编辑删除 -->
            <div v-else>
              <el-button type="text" @click="handlerEdit(scope.row, scope.$index)">{{ $t('71') }}</el-button>
              <el-button type="text" @click="handlerDel(scope.row)">{{ $t('65') }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加 -->
      <el-row v-if="isAdd" class="add-row">
        <el-form-item prop="name">
          <el-input @change.native="e => handlerName(e)" type="text" v-model="form.name" />
        </el-form-item>
        <div class="active-button">
          <el-button type="text" @click="handlerAddSave" :loading="load">{{ $t('67') }}</el-button>
          <el-button type="text" @click="isAdd = false" :disabled="load">{{ $t('66') }}</el-button>
        </div>
      </el-row>
    </el-form>
    <!-- 倒入项添加按钮 -->
    <el-button
      v-if="tableData.length <= 20"
      class="add-more"
      icon="el-icon-plus"
      @click="handlerAdd">{{
      $t('635')
    }}</el-button>
  </el-dialog>
</template>

<script>
// 删除Api
import { deleteItemImport } from 'api/payroll/wage/step2'
import { itemlist, createitem, updateitem } from 'api/payroll'

export default {
  data() {
    return {
      visible: false,
      rules: {
        name: [
          { required: true, message: this.$t('1256'), trigger: 'blur' },
          { min: 1, max: 50, message: this.$t('1399'), trigger: 'blur' }
        ]
      },
      isAdd: false, // 添加
      load: false,
      form: {
        name: '',
        cate_id: '4', // 默认
        settlement_type: 1
      },
      tableData: []
    }
  },
  methods: {
    init() {
      this.visible = true
      this.getList()
    },
    handlerName(e) {
      this.form.name = String(e.target.value).trim()
    },
    // 获取列表
    getList() {
      itemlist(this.form)
        .then(res => {
          const { data } = res
          data.forEach(item => (item.isEdit = false))
          this.$nextTick(() => (this.tableData = data))
        })
        .finally(() => {
          this.isAdd = false
          this.form.name = ''
        })
    },
    // 添加
    handlerAdd() {
      this.tableData.forEach((item, i) => {
        item.isEdit = false
      })
      this.$nextTick(() => (this.isAdd = true))
      this.form.name = ''
      this.form.id = ''
    },
    // 添加保存
    handlerAddSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.load = true
          createitem(this.form)
            .then(res => {
              this.getList()
              this.isAdd = false
              this.form.name = ''
            })
            .finally(() => (this.load = false))
        }
      })
    },
    // 保存
    handlerSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.load = true
          updateitem(this.form)
            .then(() => {
              this.getList()
              this.form.name = ''
              this.form.id = ''
            })
            .finally(() => (this.load = false))
        }
      })
    },
    // 编辑
    handlerEdit(row, index) {
      this.isAdd = false
      this.tableData.forEach((item, i) => {
        item.isEdit = i === index
      })
      this.form.name = row.name
      this.form.id = row.id
    },
    handlerCancel(row) {
      row.isEdit = false
      this.form.name = ''
      this.form.id = ''
    },
    // 删除
    handlerDel(row) {
      deleteItemImport(row)
        .then((res) => {
          this.$message({
            type: 'success',
            message: res.message
          })
          this.getList()
        })
      // this.$confirm(this.$t('1640', { x: row.name }), this.$t('229'), {
      //   confirmButtonText: this.$t('131'),
      //   cancelButtonText: this.$t('66'),
      //   type: 'warning'
      // }).then(() => {
      //   this.load = true
      //   deleteItemImport(row)
      //     .then(() => {
      //       this.getList()
      //     })
      //     .finally(() => (this.load = false))
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-more {
  display: block;
  width: 100%;
  margin-top: 10px;
  border-style: dashed;
}
.add-row {
  display: flex;
  margin: 5px 0 10px 0;
  align-items: center;
  /deep/ .el-form-item {
    flex: 1;
  }
  .active-button {
    width: 140px;
  }
}
.el-form-item {
  margin-bottom: 0;
}
.type {
  margin-bottom: 12px;
}
.el-input {
  min-width: 288px;
}
.tag {
  height: 22px;
  line-height: 22px;
  margin-left: 10px;
}
.tip-text {
  font-size: 14px;
  color: #595959;
  background: #FFF7E7;
  border: 1px solid #FFE8B9;
  border-radius: 2px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  .icon-warning {
    color: #FAAD14;
    margin-right: 9px;
  }
}
</style>
